import React from "react";
import { render } from "react-dom";
import { makeData, Logo, Tips } from "./Utils";

// Import React Table
import { Col, Container, Row } from 'reactstrap';
import ReactTable from "react-table";
import "react-table/react-table.css";

// Import React Table HOC Fixed columns
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";

import moment from 'moment'
import 'moment/locale/es'

import Select from 'react-select'

import Modal from 'react-modal';

import './tabla.css'
import { resolve } from "url";

const customStyles = {
  control: styles => ({ ...styles, backgroundColor: '#fff', height: 42, width: '90%', margin: '0 auto', marginBottom: 20, }),
}

moment.locale('es')

const ReactTableFixedColumns = withFixedColumns(ReactTable);
class Tabla extends React.Component {
  constructor() {
    super();
    this.state = {
      isOpenModal: false,
      arraySucursales: [
      // {id_sucursal: '0', nombre: 'DIRECCION', label: 'DIRECCION', value: 'DIRECCION', },
      {id_sucursal: '5f206899a20c8', nombre: 'INGENIO', label: 'INGENIO', value: 'INGENIO', },
      {id_sucursal: '5f2067c915291', nombre: 'BELLAVISTA', label: 'BELLAVISTA', value: 'BELLAVISTA', },
      {id_sucursal: '5f2071cb03380', nombre: 'ECOCENTRAL', label: 'ECOCENTRAL', value: 'ECOCENTRAL', },
      {id_sucursal: '5f2071cb0ww32', nombre: 'RUTA', label: 'RUTA', value: 'RUTA', },
      {id_sucursal: '5f2073022efb6', nombre: 'MADERO', label: 'MADERO', value: 'MADERO', },
      {id_sucursal: 'almacen', nombre: 'ALMACEN', label: 'ALMACEN', value: 'ALMACEN', },
      {id_sucursal: '5f2067c914482', nombre: 'GMART', label: 'GMART', value: 'GMART', },
      ],

      date: moment().format('YYYY-MM-DD'),
      dataTable: [],
      arrColumns: [],
      id_sucursal: '0',
      id_producto: '',
      opt: 1,
      datosVentas: [],
      textLoading: {
        status: false,
        text: 'Cargando datos...'
      }

    };
  }

  componentDidMount() {
    this.generateProgreso()
  }

  render() {
    const { arrColumns, dataTable,textLoading,loading } = this.state;

    const onRowClick = (state, rowInfo, column, instance) => {
      return {
          onClick: e => {
              console.log('A Td Element was clicked!')
              console.log('it produced this event:', e)
              console.log('It was in this column:', column)
              console.log('It was in this row:', rowInfo)
              console.log('It was in this table instance:', instance)
          }
      }
  }

    return (
      <div>
        <Row>
          <Col>
          <Select
            placeholder="INGENIO"
            // defaultInputValue="Dirección"
            options={this.state.arraySucursales}
            onChange={(val) => {this.handleInputChange(val)}}
            styles={customStyles}
          />
          </Col>
          <Col>
          <Select
            placeholder="VER VENTAS"
            // defaultInputValue="Dirección"
            options={[
              {opt: 1, nombre: 'VER VENTAS', label: 'VER VENTAS', value: 'VER VENTAS', },
              {opt: 2, nombre: 'VER COMPRAS', label: 'VER COMPRAS', value: 'VER COMPRAS', },
              {opt: 3, nombre: 'VER UTILIDADES', label: 'VER UTILIDADES', value: 'VER UTILIDADES', },
            ]}
            onChange={(val) => {this.handleInputChangeOPT(val)}}
            styles={customStyles}
          />
          </Col>
        </Row>

        <input
          type={'date'}
          value={this.state.date}
          onChange={(event) => { this.setState({ date: event.target.value, }); setTimeout(() => { this.generateProgreso() }, 1000) }}
        />

        <ReactTableFixedColumns
          data={dataTable}
          columns={arrColumns}
          defaultPageSize={100}
          style={{ height: 500 }}
          className="-striped -highlight"
          getTdProps={(state, rowInfo, column, instance) => {
            return {
              onClick: (e, handleOriginal) => {

                let idProducto = rowInfo.original.id_producto;
                this.state.textLoading.status = true
                this.setState({id_producto: idProducto,isOpenModal:true,textLoading});

                setTimeout( () => {
                  this.getInfoVentasByDay()
                },500)

                if (handleOriginal) {
                  handleOriginal()
                }
              }
            }
          }}
        />

        <Modal
          overlayClassName="Overlay__aplicaciones"
          isOpen={this.state.isOpenModal}
          onRequestClose={() => { this.setState({isOpenModal: false,datosVentas:[]}) }}
          contentLabel=""
          className="modalCustom"
          ariaHideApp={false}
          >
          <div className="modalContainer">
            <div className="modalHeader__operador">
              <h5 className="col-11 text-center modalHeader_operador_title">Datos</h5>
            </div>
            <div className="modalBody__operador">
              <table className="table table-sm table-hover">
                <thead>
                  <tr>
                    <th>Fecha</th>
                    <th>KG Vendidos</th>
                    <th>Venta $</th>
                    <th>Crédito</th>
                    <th>P. Unitario</th>
                  </tr>
                </thead>
                <tbody>
                    {
                    (this.state.datosVentas.length>0) ?
                      this.state.datosVentas.map((t,e) => (
                        <tr>
                          <td> { moment(t.fecha).format('DD/MM/YYYY') } </td>
                          <td> {t.kg} </td>
                          <td> { "$ "+t.venta_pesos } </td>
                          <td> {t.credito} </td>
                          <td> { "$ "+t.precio_unitario} </td>
                        </tr>
                      ))
                      :
                      <tr>
                        <td colSpan="5" style={{textAlign:'center'}}>No hay datos</td>
                      </tr>
                  }
                </tbody>
              </table>

              <div></div>
            </div>
          </div>
        </Modal>
        <br />
        <Logo />

        {
          (this.state.textLoading.status) ?
          <div className="loadScreen">
            <img src={'img/hgapp/loading.gif'} alt="loading"/>
            <p>{this.state.textLoading.text}</p>
          </div>
          :
          <></>
        }

      </div>
    );
  }

  handleInputChange(data) {
    this.setState({ id_sucursal: data.id_sucursal });
    setTimeout( () => {
      this.generateProgreso()
    }, 100)
  }

  handleInputChangeOPT(data) {
    this.setState({ opt: data.opt });
    setTimeout( () => {
      this.generateProgreso()
    }, 100)
  }

  getInfoVentasByDay() {
    const {date,id_sucursal,id_producto,textLoading} = this.state;
    const fecha = moment(date).format('YYYY-MM-DD')
    this.setState({date:fecha})

    if(id_sucursal === '0') {
      alert('Error, no haz seleccionado una sucursal.')
      return false
    }

    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=getInfoVentasByDay", this.headersPOST({ day: fecha, id_sucursal, id_producto }))
    .then(response0 => response0.json())
    .then((response0) => {
      console.log(response0)
      this.state.textLoading.status = false
      this.setState({datosVentas: response0,textLoading})
    })

  }

  generateProgreso(pageSize,page,sorted,filtered) {
    const { date, id_sucursal, opt,textLoading } = this.state
    textLoading.status = true;
    this.setState({textLoading});

    //Generando días del mes
    const year = moment( date ).format('YYYY'),
    month = moment( date ).format('MM')

    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=generateReporte", this.headersPOST({pageSize,page, date, id_sucursal, opt, year, month }))
    .then(response0 => response0.json())
    .then((response0) => {

      //Generamos array de tabla
      let year    = moment( date ).format('YYYY'),
      month       = moment( date ).format('MM'),
      daysInMonth = moment( date ).daysInMonth(),
      arrColumns  = [
        {
          Header: "",
          fixed: "left",
          columns: [
          {
            Header: "Producto",
            accessor: "nombre",
            width: 200
          }
          ]
        },
      ];

      let Header1 = '',
      Header2 = '',
      Header3 = '',
      Header4 = ''

      if(opt === 1) {
        Header1 =  "Venta KG"
        Header2 = "TOTAL VENTA"
        Header3 = "TOTAL COMPRA"
        Header4 = "UTILIDAD"

        for(var a = 1; a <= daysInMonth; a++) {
          const nameDay = moment( `${year}-${month}-${a}` ).format('dddd')

          arrColumns.push({
            Header: `${nameDay} ${a}`,
            columns: [
            {
              Header:Header1,
              accessor: `kg_d${a}`,
              width: 150
            },{
              Header:Header2,
              accessor: `p_d${a}`,
              width: 150
            },{
              Header:Header3,
              accessor: `p_dcompra${a}`,
              width: 150
            },{
              Header:Header4,
              accessor: `p_utilidad${a}`,
              width: 150
            },
            ],
          })
        }

        arrColumns.push({
          Header: `Sumatoria`,
          columns: [
          {
            Header:Header1,
            accessor: `kg_d${daysInMonth+1}`,
            width: 150
          },{
            Header:Header2,
            accessor: `p_d${daysInMonth+1}`,
            width: 150
          },{
            Header:Header3,
            accessor: `p_dcompra${daysInMonth+1}`,
            width: 150
          },{
            Header:Header4,
            accessor: `p_utilidad${daysInMonth+1}`,
            width: 150
          },
          ],
        })


      } else if(opt === 2) {
        Header1 =  "Precio de compra"
        Header2 = "Precio de venta"

        for(var a = 1; a <= daysInMonth; a++) {
          const nameDay = moment( `${year}-${month}-${a}` ).format('dddd')

          arrColumns.push({
            Header: `${nameDay} ${a}`,
            columns: [
            {
              Header:Header1,
              accessor: `kg_d${a}`,
              width: 150
            },{
              Header:Header2,
              accessor: `p_d${a}`,
              width: 150
            },
            ],
          })
        }

        arrColumns.push({
        Header: `Sumatoria`,
        columns: [
        {
          Header:Header1,
          accessor: `kg_d${daysInMonth+1}`,
          width: 150
        },{
          Header:Header2,
          accessor: `p_d${daysInMonth+1}`,
          width: 150
        },
        ],
      })


      } else if(opt === 3) {
        // Header1 = "Venta KG"
        // Header2 = "Utilidad"
      }

      

      textLoading.status = false;

      const data = {
        dataTable: response0,
        arrColumns,
        textLoading
      }

      this.setState({
        dataTable: response0,
        arrColumns,
        textLoading,
        loading: false
      })

    })

  }

  headersPOST(data) {
    return {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(data),
    }
  }

}

export default Tabla;
